import { NotificationManager } from 'react-notifications';
import { format } from 'date-fns';

export function formatCurrency(num, sym = '$') {
  return `${sym}${num.toFixed(2)}`;
}

export const truncate = (str, len) =>
  str.length <= len ? `${str.slice(0, len)}` : `${str.slice(0, len)}...`;

export const formatDate = (date, form = 'dd-MM-yyyy HH:mm') =>
  format(new Date(date), form);

export function sumCartPrice(arr) {
  return arr?.reduce((acc, item) => {
    acc += item?.qty * item?.price;
    return acc;
  }, 0);
}

export const notification = (type, message) => {
  const msg = message;
  switch (type) {
    case 'info':
      NotificationManager.info(msg);
      break;
    case 'success':
      NotificationManager.success(msg);
      break;
    case 'warning':
      NotificationManager.warning(msg);
      break;
    case 'error':
      NotificationManager.error(msg);
      break;
  }
};
